module.exports = __webpack_public_path__ + "static/img/premiere.aa5d7989.png";